import type { Customer } from '#/domain/customerAccess/Customer'
import type { CustomerAccessRepository } from '#/domain/customerAccess/CustomerAccessRepository'

export class GetAccessibleCustomersUseCase {
  constructor(private readonly repository: CustomerAccessRepository) {}

  execute(): Promise<Customer[]> {
    return this.repository.findAccessibleCustomers()
  }
}
